const navbar = () => {
  const navbar = document.querySelector(".navbar");

  if (!navbar) return;

  const links = navbar.querySelectorAll(".menu-item a");
  if (links.length > 0) {
    links.forEach(link => {
      link.addEventListener("click", () => {
        navbar.classList.remove("open");
      })
    })
  }

  const toggler = navbar.querySelector(".navbar__toggler");
  const collapse = navbar.querySelector(".navbar__collapse");
  if (toggler && collapse) {
    toggler.addEventListener("click", () => {
      navbar.classList.toggle("open");
    });
  }

  const anchors = document.querySelectorAll('a[href^="#"]');
  if (anchors.length > 0) {
    anchors.forEach(anchor => {
      anchor.addEventListener("click", (e) => {
        e.preventDefault();

        const target = document.querySelector(anchor.getAttribute("href"));

        if (target) {
          const navbarHeight = navbar ? navbar.offsetHeight : 0;

          const targetPosition =
            target.getBoundingClientRect().top +
            window.pageYOffset -
            navbarHeight;

          window.scrollTo({
            top: targetPosition,
            behavior: "smooth",
          });
        }
      });
    });
  }


};

export default navbar;
